import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/flow/:name',
      name: 'flow',
      component: () => import(/* webpackChunkName: "flow" */ './views/Flow.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/pages/:first/:second',
      name: 'iovation',
      component: () => import(/* webpackChunkName: "pages" */ './views/Pages.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login/:error?',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
      path: '/theme',
      name: 'theme',
      component: () => import(/* webpackChunkName: "settings" */ './views/settings/Theme.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "settings" */ './views/settings/Default.vue'),
      meta: {
        requiresAuth: true,
      },
    },
  ],
});
